export const knowledgeBaseEn = {
  title: "Knowledge Base",
  subtitle: "Enterprise knowledge search and Q&A",
  searchPlaceholder: "Search documents, articles, policies...",
  searchButton: "Search",
  resultsTitle: "Results",
  fileResultsTitle: "Files",
  folderResultsTitle: "Folders",
  resultCount: "{count} results",
  emptyState: "No results found. Try another keyword.",
  emptyStateHint: "Try different keywords or check your spelling",
  openInSharePoint: "Open in SharePoint",
  open: "View",
  preview: "Preview",
  previewTitle: "Content preview",
  previewSubtitle: "Matched content has been located for preview",
  previewLoading: "Loading preview content...",
  previewFailed: "Failed to load preview. Please try again.",
  previewNoContent: "No text content is available for this result.",
  previewDocumentExcerptHint:
    'The current view shows searchable excerpt content. Click \"View\" to open the full original file.',
  previewMetaSource: "Source",
  previewMetaLength: "Length",
  previewSourceType: {
    article: "Article body",
    documentAggregated: "Aggregated retrieval chunks",
    documentSnippet: "Snippet fallback",
  },
  previewEmbedFallback:
    'Embedded preview is unavailable. Showing text preview instead. You can still click "View" to open the original file.',
  previewHint:
    'Preview is for quick reading. Click "View" to open the original content.',
  lastModified: "Last updated",
  fileType: "File type",
  createdBy: "Created by",
  loading: "Searching...",
  clear: "Clear",
  relevance: "Relevance",
  suggestions: {
    loading: "Loading suggestions...",
    empty: "No suggestions",
    clearRecent: "Clear",
    removeOne: "Remove this query",
    clearFailed: "Failed to clear recent searches",
    removeFailed: "Failed to remove recent search",
    group: {
      RECENT_SEARCH: "Recent searches",
      TOP_QUERY: "Top queries",
      TITLE: "Documents & articles",
    },
  },

  // Search types
  searchType: {
    hybrid: "Hybrid",
    keyword: "Keyword",
    semantic: "Semantic",
  },

  // Document types
  docType: {
    POLICY: "Policy",
    MANUAL: "Manual",
    TUTORIAL: "Tutorial",
    FAQ: "FAQ",
    GENERAL: "General",
    ARTICLE: "Article",
    document: "Document",
    article: "Article",
  },

  // Authority levels
  authorityLevel: {
    OFFICIAL: "Official",
    EXPERT: "Expert",
    PUBLISHED: "Published",
    DRAFT: "Draft",
  },

  // Home page
  home: {
    greeting: {
      morning: "Good morning",
      afternoon: "Good afternoon",
      evening: "Good evening",
    },
    create: "Create",
    chat: "Chat",
    pickUpWhereYouLeftOff: "Pick up where you left off",
    defaultCategory: "IT Operations",
    editedAt: "Edited {time}",
    recently: "Recently",
    placeholders: [
      { title: "Getting Started Guide", time: "2 hours ago" },
      { title: "Company Policies", time: "5 hours ago" },
      { title: "IT Support FAQ", time: "1 day ago" },
      { title: "Onboarding Checklist", time: "2 days ago" },
      { title: "Benefits Overview", time: "3 days ago" },
      { title: "Travel Guidelines", time: "1 week ago" },
    ],
    recentlyVisited: "Recently visited",
    recent: "Recent",
    starred: "Starred",
    searchArticles: "Search articles",
    createArticle: "Create article",
    noRecentArticles: "No recent articles",
    quickStart: {
      title: "Quick Start",
      items: [
        {
          id: "gettingStarted",
          title: "Getting Started",
          href: "https://faradayandfuture.sharepoint.com/:w:/g/UP2U%20Subcommitee/IQBVROVmse3hSJm5jD8RvuTRAbcEP5AjabbQMgzlQ68Q2Jc?e=0ShGQV",
        },
        {
          id: "howTo",
          title: "How to",
          href: "https://faradayandfuture.sharepoint.com/:w:/g/UP2U%20Subcommitee/IQCLpP7pGqICSLF7i-r8VvMZAfSzmeLzA_9rCvgOIQTJ3Ug?e=T1AiO6",
        },
        {
          id: "faq",
          title: "FAQ",
          href: "https://faradayandfuture.sharepoint.com/:w:/g/UP2U%20Subcommitee/IQAlO1v8VYkrSJQBqe66InPkAce-YZ90gnn9eKDynz6bmAo?e=EmhJaD",
        },
      ],
    },
  },
  articleDetail: {
    title: "Article details",
    subtitle: "View internal article content",
    back: "Back to Knowledge Base",
    loading: "Loading article...",
    loadFailed: "Failed to load article. Please try again.",
    status: {
      DRAFT: "Draft",
      PUBLISHED: "Published",
      ARCHIVED: "Archived",
    },
    fields: {
      status: "Status",
      lastUpdated: "Last updated",
    },
  },
  rebuildIndex: {
    action: "Rebuild index",
    confirmTitle: "Rebuild index?",
    confirmDescription:
      "This will trigger a full index rebuild and may take some time.",
    success: "Rebuild task triggered",
    failed: "Failed to rebuild index. Please try again later.",
  },
  fullSync: {
    action: "Full sync",
    confirmTitle: "Trigger full sync?",
    confirmDescription:
      "This will fetch all SharePoint documents and update the local index.",
    success: "Full sync task triggered",
    failed: "Failed to trigger full sync. Please try again later.",
    viewDetails: "View details",
  },
  deltaSync: {
    action: "Delta sync",
    confirmTitle: "Trigger delta sync?",
    confirmDescription:
      "This will sync changed SharePoint items and may fall back to a full sync if needed.",
    success: "Delta sync task triggered",
    failed: "Failed to trigger delta sync. Please try again later.",
    viewDetails: "View details",
    strategyHint:
      "Delta first; fall back to full sync if the cursor is missing or invalid.",
  },
  syncTaskDetail: {
    title: "Sync task details",
    subtitle: "View sync task status and stats",
    back: "Back to sync history",
    refresh: "Refresh",
    viewSkipped: "View skipped items",
    viewProcessed: "View processed items",
    viewProcessing: "View processing items",
    viewFailed: "View failed items",
    loading: "Loading task status...",
    loadFailed: "Failed to load task status",
    taskNotFound: "Sync task not found",
    overviewTitle: "Task overview",
    overviewDescription: "Shows task status and statistics",
    fields: {
      taskId: "Task ID",
      status: "Status",
      totalItems: "Total",
      processedItems: "Processed",
      processingItems: "Processing",
      failedItems: "Failed",
      skippedItems: "Skipped",
      processedTokens: "Tokens processed",
      processedChunks: "Chunks processed",
      error: "Error",
      lastChecked: "Last checked",
    },
    status: {
      PENDING: "Pending",
      SYNCING: "Syncing",
      COMPLETED: "Completed",
      FAILED: "Failed",
    },
  },
  syncTaskList: {
    entry: "Sync history",
    title: "Sync history",
    subtitle: "View recent sync history",
    back: "Back to Knowledge Base",
    refresh: "Refresh",
    loading: "Loading task list...",
    loadFailed: "Failed to load task list",
    empty: "No sync tasks yet",
    overviewTitle: "Task list",
    totalLabel: "{count} tasks",
    lastChecked: "Last checked {time}",
    table: {
      taskId: "Task ID",
      status: "Status",
      triggerSource: "Trigger",
      total: "Total",
      processed: "Processed",
      processing: "Processing",
      failed: "Failed",
      skipped: "Skipped",
      tokens: "Tokens",
      chunks: "Chunks",
      createdAt: "Created at",
      action: "Action",
      view: "View details",
      terminate: "Terminate",
    },
    triggerSource: {
      MANUAL_FULL: "Manual full",
      MANUAL_DELTA: "Manual delta",
      DELTA_FALLBACK: "Delta fallback",
      SCHEDULED_FULL: "Scheduled full",
      UNKNOWN: "Unknown",
    },
    status: {
      PENDING: "Pending",
      SYNCING: "Syncing",
      COMPLETED: "Completed",
      FAILED: "Failed",
    },
    terminateConfirmTitle: "Terminate sync task?",
    terminateConfirmDescription:
      "This will stop task {taskId} immediately and mark it as failed.",
    terminateConfirmAction: "Terminate",
    terminateSuccess: "Sync task terminated",
    terminateFailed: "Failed to terminate sync task",
  },
  syncTaskSkipped: {
    title: "Skipped items",
    subtitle: "Review skipped files and reasons",
    back: "Back to task details",
    refresh: "Refresh",
    loading: "Loading skipped items...",
    loadFailed: "Failed to load skipped items",
    empty: "No skipped items",
    taskNotFound: "Sync task not found",
    overviewTitle: "Skipped list",
    totalLabel: "{count} records",
    lastChecked: "Last checked {time}",
    table: {
      sourceType: "Source",
      filename: "Filename",
      fileExtension: "Extension",
      mimeType: "MIME type",
      reason: "Reason",
      createdAt: "Recorded at",
    },
    sourceType: {
      SP_DOCUMENT: "SharePoint",
      ARTICLE: "Article",
    },
  },
  syncTaskProcessed: {
    title: "Processed items",
    subtitle: "Review processed files",
    back: "Back to task details",
    refresh: "Refresh",
    loading: "Loading processed items...",
    loadFailed: "Failed to load processed items",
    empty: "No processed items",
    taskNotFound: "Sync task not found",
    overviewTitle: "Processed list",
    totalLabel: "{count} records",
    lastChecked: "Last checked {time}",
    table: {
      sourceType: "Source",
      filename: "Filename",
      fileExtension: "Extension",
      mimeType: "MIME type",
      ragflowId: "RAGFlow document ID",
      size: "Size",
      tokenCount: "Tokens",
      chunkCount: "Chunks",
      createdAt: "Recorded at",
    },
    sourceType: {
      SP_DOCUMENT: "SharePoint",
      ARTICLE: "Article",
    },
  },
  syncTaskProcessing: {
    title: "Processing items",
    subtitle: "Review items currently processing",
    back: "Back to task details",
    refresh: "Refresh",
    loading: "Loading processing items...",
    loadFailed: "Failed to load processing items",
    empty: "No processing items",
    taskNotFound: "Sync task not found",
    overviewTitle: "Processing list",
    totalLabel: "{count} records",
    lastChecked: "Last checked {time}",
    table: {
      sourceType: "Source",
      filename: "Filename",
      fileExtension: "Extension",
      mimeType: "MIME type",
      ragflowId: "RAGFlow Doc ID",
      size: "Size",
      tokenCount: "Tokens",
      chunkCount: "Chunks",
      createdAt: "Recorded at",
    },
    sourceType: {
      SP_DOCUMENT: "SharePoint",
      ARTICLE: "Article",
    },
  },
  syncTaskFailed: {
    title: "Failed items",
    subtitle: "Review failed files and reasons",
    back: "Back to task details",
    refresh: "Refresh",
    loading: "Loading failed items...",
    loadFailed: "Failed to load failed items",
    empty: "No failed items",
    taskNotFound: "Sync task not found",
    overviewTitle: "Failed list",
    totalLabel: "{count} records",
    lastChecked: "Last checked {time}",
    table: {
      sourceType: "Source",
      filename: "Filename",
      fileExtension: "Extension",
      mimeType: "MIME type",
      error: "Error",
      createdAt: "Recorded at",
    },
    sourceType: {
      SP_DOCUMENT: "SharePoint",
      ARTICLE: "Article",
    },
  },

  // Analytics panel
  analytics: {
    title: "Analytics",
    viewAll: "View all",
    contentOverview: "Content overview",
    projectOverview: "Project overview",
    createdArticles: "Created articles",
    draft: "Draft",
    published: "Published",
    views: "Views",
    reads: "Reads",
    likes: "Likes",
    dislikes: "Dislikes",
    brokenLinks: "Broken links",
    note: "Note: This data represents analytics for all contributors.",
    timeRange: {
      lastWeek: "Last week",
      lastMonth: "Last month",
      allTime: "All time",
    },
  },

  // Activity feed
  activity: {
    title: "Activity",
    all: "All",
    mentions: "Mentioned me",
    comments: "Article comments",
    noActivity: "No activity",
    unreadCount: "{count} unread",
    lastUpdated: "Last updated: {time}",
    description: {
      mention: "mentioned you",
      comment: "commented on an article",
      like: "liked your article",
    },
  },

  // AI Q&A
  ask: {
    title: "AI Q&A",
    subtitle:
      "Get accurate, traceable answers from the enterprise knowledge base",
    placeholder:
      "Ask a question, e.g., What is the expense reimbursement process?",
    submit: "Ask",
    backToKnowledgeBase: "Back to Knowledge Base",
    semanticSearchTitle: "Smart Search",
    confidence: "Confidence",
    responseTime: "Response time",
    model: "Model",
    helpful: "Was this answer helpful?",
    sources: "Sources",
    feedbackSuccess: "Thanks for your feedback!",
    feedbackFailed: "Failed to submit feedback",
    askFailed:
      "Q&A service is temporarily unavailable. Please try again later.",
    questionRequired: "Please enter your question",
  },
  chatbot: {
    ariaLabel: "AI Chat",
    title: "AI Assistant",
    emptyTitle: "Knowledge Base Assistant",
    emptyDescription:
      "Ask me anything about company policies, procedures, or documents.",
    inputPlaceholder: "Ask a question...",
    scoreLabel: "Score: {score}%",
  },
  recentlyVisited: {
    editedAt: "Edited {time}",
    departmentFallback: "IT Operations",
  },
  upload: {
    title: "Upload to Knowledge Base",
    subtitle: "Files will be uploaded to the default SharePoint library",
    button: "Upload File",
    success: "Upload successful",
    failed: "Upload failed. Please try again.",
    validation: {
      required: "Please select a file to upload",
    },
  },
  editor: {
    entry: "New Article",
    title: "Knowledge Article Editor",
    subtitle: "Single-user mode (stored in database)",
    save: "Save",
    saving: "Saving...",
    created: "Article created",
    saved: "Article saved",
    saveFailed: "Save failed. Please try again.",
    articleId: "Article ID: {id}",
    validation: {
      titleRequired: "Please enter a title",
      contentRequired: "Please enter content",
    },
    fields: {
      title: "Title",
      content: "Content",
      titlePlaceholder: "Enter article title",
      contentPlaceholder: "Type “/” to insert blocks",
    },
    commands: {
      heading1: "Heading 1",
      heading2: "Heading 2",
      heading3: "Heading 3",
      callout: "Callout",
      bulletList: "Bulleted list",
      orderedList: "Numbered list",
    },
    layout: {
      breadcrumbRoot: "AI-Workspace",
      breadcrumbSection: "Product",
      share: "Share",
      lastEdited: "Last edited: {time}",
      draftTitle: "Untitled",
      addIcon: "Add icon",
      addCover: "Add cover",
      authorName: "Chentao Jia",
      sampleDate: "Dec 23, 2025",
      outlineTitle: "Outline",
      outlineEmpty: "Use # to create headings, outline will auto-generate",
      insertCallout: "Insert Callout",
      bulletList: "List",
      orderedList: "Numbering",
      comment: "C",
      modified: "edited",
    },
  },
  outline: {
    entry: "Outline Editor",
    title: "Outline Editor (Pilot)",
    subtitle: "Embedded Outline for internal knowledge base evaluation",
    embedHint: "If embedding is blocked, open in a new tab using the button.",
    open: "Open in new tab",
    missingUrl: "Outline URL is not configured. Set NEXT_PUBLIC_OUTLINE_URL.",
    iframeTitle: "Outline Editor",
  },
  validation: {
    queryRequired: "Please enter a search keyword",
  },
  time: {
    justNow: "just now",
    minutesAgo: "{count} minutes ago",
    hoursAgo: "{count} hours ago",
    daysAgo: "{count} days ago",
    yesterday: "yesterday",
    recently: "Recently",
  },
  errors: {
    searchFailed: "Search failed. Please try again.",
    searchProviderUnavailable: "Search provider unavailable",
    searchProviderUnavailableDescription:
      "Please ask an admin to verify the embedding provider credentials or billing.",
  },
  placeholders: {
    articles: [
      { title: "Getting Started Guide", time: "2 hours ago" },
      { title: "Company Policies", time: "5 hours ago" },
      { title: "IT Support FAQ", time: "1 day ago" },
      { title: "Onboarding Checklist", time: "2 days ago" },
      { title: "Benefits Overview", time: "3 days ago" },
      { title: "Travel Guidelines", time: "1 week ago" },
    ],
  },
};
